import { FormikProps } from "formik";
import React, { useState } from "react";
import { MainFormType, StepType } from "./CreateServiceModal";
import OrderInformation from "./PackagePickup/OrderInformation";

interface PackagePickupProps {
  form: FormikProps<MainFormType>; // The main form from CreateServiceModal
  setStep: (step: StepType) => void;
}

const PackagePickup = ({ form, setStep }: PackagePickupProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleOrderInformationSubmit = () => {
    console.log("handle order information submit called!");
    // event.preventDefault();
    // Validate order information fields
    const orderErrors: any = {};
    const orderInfo = form.values.package_pickup_meta.orderInformation;

    if (!orderInfo.firstName) orderErrors.firstName = "This field is required";
    if (!orderInfo.lastName) orderErrors.lastName = "This field is required";
    if (!orderInfo.phone) orderErrors.phone = "This field is required";

    if (Object.keys(orderErrors).length === 0) {
      setIsLoading(true)
      setTimeout(() => {
        setIsLoading(false)
        setStep("pickup");
      }, 300)
    } else {
      // Set touched and errors for order information fields
      form.setTouched({
        ...form.touched,
        package_pickup_meta: {
          ...form.touched.package_pickup_meta,
          orderInformation: {
            firstName: true,
            lastName: true,
            phone: true,
          },
        },
      });

      form.setErrors({
        ...form.errors,
        package_pickup_meta: {
          ...form.errors.package_pickup_meta,
          orderInformation: orderErrors,
        },
      });
    }

    console.log(orderErrors, "orderErrors");
  };

  return (
    <div>
      <OrderInformation form={form} onSubmit={handleOrderInformationSubmit} isLoading={isLoading} />
    </div>
  );
};

export default PackagePickup;
